// extracted by mini-css-extract-plugin
export default {"root":"Header_root__QqAr5","box":"Header_box__Y-J9j"};